import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/src/app/(site)/about/origins/components/origins/index.tsx");
